import * as types from './types';

export const init = () => ({
  type: types.INIT,
});

export const changeTimelineSizeCap = (increase: boolean) => ({
  type: types.CHANGE_SIZE_CAP_ACTION,
  increase,
});
